export default __webpack_public_path__ + "static/GLAMOUR_mobile@3x-931317996ebd4148acb4ec99f024ad99.png";